import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_2 = { class: "row no-padding q-pt-lg justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transportSolutionTab, (transportSolution) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row no-padding col col-xs-6 col-sm-6 col-md-4 col-lg-3 q-mx-sm q-mb-md",
          key: transportSolution.id
        }, [
          _createVNode(_component_Card, {
            onClick: ($event: any) => (
            _ctx.changeTransport(transportSolution),
            _ctx.changePage(_ctx.tabOfViewName[_ctx.currentPage + 1])
          ),
            title: transportSolution.name,
            desc: "",
            selectable: true,
            url: transportSolution.cover ? `${_ctx.baseApi || ''}${transportSolution.cover}` : 'transport',
            notification: 0,
            isProduct: true
          }, null, 8, ["onClick", "title", "url"])
        ]))
      }), 128))
    ])
  ]))
}